import { render, staticRenderFns } from "./StudentsItem.vue?vue&type=template&id=a826333c&"
import script from "./StudentsItem.vue?vue&type=script&lang=ts&"
export * from "./StudentsItem.vue?vue&type=script&lang=ts&"
import style0 from "./StudentsItem.vue?vue&type=style&index=0&id=a826333c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports